import Android1 from './images/Android_1_150_kr-ko.png';
import Android2 from './images/Android_Dodaj_150_kr-ko.png';
import Ios1 from './images/IOS_1_150_kr-ko.png';
import Ios2 from './images/IOS_Dodaj_150_kr-ko.png';
import Last from './images/ios_android_3.png';

import VolumeUp from './images/dailyTutorial/volume-up.svg';
import HandsUp from './images/dailyTutorial/hand-up.svg';
import VolumeUpBlank from './images/dailyTutorial/volume-up-blank.svg';
import TranslationBlank from './images/dailyTutorial/icon-translate-blank.svg';
import HintBlank from './images/dailyTutorial/idea-blank.svg';
import InfoBlank from './images/dailyTutorial/information-blank.svg';
import GreenCircle from './images/dailyTutorial/green-circle.svg';
import YellowCircle from './images/dailyTutorial/yelow-circle.png';
import Microphone from './images/dailyTutorial/icon-microphone.svg';
import ScreenOne from './images/dailyTutorial/samouczek_czat_1.png';
import ScreenTwo from './images/dailyTutorial/samouczek_czat_2.png';
import ScreenThree from './images/dailyTutorial/samouczek_czat_3.png';
import ScreenFour from './images/dailyTutorial/samouczek_czat_4.png';
import Tutorial from './images/dailyTutorial/samouczek-fiolet.svg';

import Micro from './images/wordTrainerTutorial/icon-microphone.png';
import Voice from './images/wordTrainerTutorial/volume-up.svg';
import Person from './images/wordTrainerTutorial/user.svg';

export default {
	passwordRestart: {
		title: '비밀번호 재설정',
		password: '비밀번호',
		repeatPassword: '비밀번호 반복',
		restartPawssord: '비밀번호 재설정',
	},

	paywall: {
		title: '계속 학습하려면 계획을 선택하세요',
		buy: '구매',
		savePayment: '안전한 결제는',
		skip: '건너뛰기',
		pickPlan: '계획 선택',
		endPlanFirstPart: '귀하의 접근은',
		endPlanSecondPart: '일 후 종료됩니다.',
		endPlanAditionalPart: '일',
		paymentTitle: '요약',
		product: '제품:',
		plan: 'SynthiAi 계획',
		forLong: '접근 기간:',
		data: '데이터:',
		nameAndSurname: '이름:',
		paymentForm: '결제 방법:',
		toPay: '오늘 지불:',
		accept: '동의',
		rules: '약관',
		payingAccept: '결제 시 동의',
		paymentRules: '"PayU 결제 규정"',
		buyAndPay: '구매 및 결제',
	},
	paymentStatus: {
		veryfication: '결제가 처리 중입니다...',
		title: '결제 완료',
		success: '성공!',
		failure: '실패!',
		subtitle: '곧 로그인 페이지로 리디렉션됩니다.',
		textInfo: `결제가 성공적으로 처리되었습니다. 이제 등록 페이지에서 비밀번호를 설정할 수 있습니다. 몇 분 후 비밀번호를 설정할 수 있는 링크가 포함된 이메일을 받게 됩니다.

스팸 폴더를 포함하여 이메일을 확인해 주세요. "synthiai"를 검색하여 쉽게 찾을 수 있습니다. 문제가 있으면: contact@synthiaiapp.com으로 문의해 주세요.`,
		login: '로그인하러 가기',
	},
	register: {
		steps: {
			register: '등록',
			package: '패키지',
			summarize: '요약',
			step: '단계 ',
		},
		stepOne: {
			password: '비밀번호',
			errorGoogle: '이메일로 로그인하세요.',
			title: '등록',
			nameAndSurname: '이름',
			placeholderNameAndSurname: '예: 아담 스미스',
			email: '이메일',
			placeholderEmail: '예: 예시@synthiaiapp.com',
			password: '비밀번호',
			start: '계정 생성',
			subtitle:
				'비밀번호는 최소 8자 이상이어야 하며 대문자, 소문자 및 숫자가 포함되어야 합니다.',
			passwordError1: '비밀번호는 최소 8자 이상이어야 합니다.',
			passwordError2: '비밀번호는 최소 1개의 대문자를 포함해야 합니다.',
			passwordError3: '비밀번호는 최소 1개의 소문자를 포함해야 합니다.',
			passwordError4: '비밀번호는 최소 1개의 숫자를 포함해야 합니다.',
			passwordError5: '비밀번호는 동일해야 합니다.',
		},
		stepTwo: {
			title: '계획 선택',
			month: '개월',
			months: '개월',
			months2: '개월',
			value: '€/개월',
			pick: '선택',
			nowPay: '지금 결제',
			saveOne: '저장',
			buy: '구매',
			savePayment: '안전한 결제는',
		},
		stepThree: {
			title: '요약',
			product: '제품:',
			plan: 'Synthi Ai 계획',
			forLong: '접근 기간:',
			data: '데이터:',
			nameAndSurname: '이름:',
			paymentForm: '결제 방법:',
			toPay: '오늘 지불:',
			accept: '동의',
			rules: '규칙',
			payingAccept: '결제 시 동의',
			paymentRules: '"PayU 결제 규정"',
			buyAndPay: '구매 및 결제',
		},
	},
	firstLogin: {
		createPasswordForAcoount: '계정 비밀번호 설정',
		typeEmail: '이메일 입력',
		useSameEmail: '구매 시 제공한 이메일을 사용하세요',
		typePassword: '비밀번호 입력',
		confirmPassword: '비밀번호 확인',
		createPassword: '비밀번호 생성',
		errorLogin: '이메일이나 비밀번호가 정확한지 확인하세요.',
		createdPassword: '이미 비밀번호를 생성하셨나요?',
		clickToLogin: '여기를 클릭하여 로그인',
	},
	login: {
		dontHavePassword: '아직 비밀번호가 없나요?',
		getPassword: '여기를 클릭하여 액세스',
		title: '로그인',
		email: '이메일',
		password: '비밀번호',
		textSub: '비밀번호를 잊으셨나요? 재설정',
		restart: '여기',
		restartPasswordText:
			'이메일을 입력하여 비밀번호를 재설정하세요. 비밀번호는 이메일로 전송됩니다.',
		placeholder: '이메일을 입력하세요...',
		resetPassword: '비밀번호 재설정',
		buttonText: '로그인',
		errorLogin: '이메일 또는 비밀번호가 정확한지 확인하세요.',
		passwordResterted: '비밀번호가 재설정되었습니다. 이메일을 확인하세요.',
		passwordError: '이메일을 찾을 수 없습니다.',
		mobileAppBannerText: '우리 앱을 발견하세요!',
	},
	navBar: {
		home: '홈',
		learn: '학습',
		profile: '프로필',
	},
	home: {
		hello: '안녕하세요',
		question: '오늘 무엇에 대해 이야기하고 싶으신가요?',
		answer: '대화를 시작하세요',
		forYou: '추천 콘텐츠',
		popularNow: '지금 인기',
		doYouKnow: '알고 계셨나요?',
		funFact: '오늘의 사실',
		new: '새로운',
		check: '확인',
		yourFavorite: '내 즐겨찾기',
		newTitle: '단어 트레이너',
		newSubtitle: '단어 발음 연습하기',
		talkWith: '무엇이든 대화하세요',
		photoConversation: {
			photoConversationMode: '사진 대화 모드',
			goToChatTakeAPhoto:
				'채팅으로 이동하여 사진을 찍거나 갤러리에서 선택하고 이야기하세요.',
			check: '확인',
			new: '신규',
		},
	},
	learn: {
		wordTrainer: {
			title: '단어 트레이너',
			subtitle: '단어 발음 연습하기',
			new: '새로운',
		},
		flashcardV2: {
			new: '새로운',
			sport: '스포츠',
			continue: '계속',
			nice: '멋져요!',
			congratulation: '축하합니다!',
			category: '카테고리',
			textAfterCategory: '비밀이 없습니다!',
			pickNewCategory: '새 카테고리 선택',
			showResult: '결과 보기',
			createWordWithLetters: '섞인 글자로 단어 만들기',
			know: '알아요',
			dontKnow: '모르겠어요',
			metchWords: '쌍 맞추기',
			addNewCategory: '새 카테고리 추가',
			personalizeLearning: '학습을 개인화하려면 자신의 카테고리를 만드세요.',
			typeNewCategory: '새 카테고리 이름 입력',
			save: '저장',
			weAreCreatingCategoryForYou: '새 카테고리를 생성 중입니다:',
			start: '시작',
			howToUseFlashcard: '플래시카드 사용법',
			knowFlashcard:
				'“모르겠어요” 또는 “알아요”를 클릭하여 자신의 지식을 평가하세요.',
			dontKnowFlashcard: '“알아요”로 표시된 플래시카드는 반복되지 않습니다.',
			clickToHear: '단어를 들으려면 클릭하세요.',
			clickForDefinition: '정의를 보려면 클릭하세요',
			clickForTranslation: '번역 및 예시를 보려면 클릭하세요',
			close: '닫기',
			clickCategoryToStart: '선택한 카테고리를 클릭하여 학습을 시작하세요.',
			lookAsProgressBar:
				'카테고리 아래 진행 바는 여러분이 이미 마스터한 단어를 보여줍니다.',
			clickToSetupFavaroiteFlashcard:
				'카테고리를 즐겨찾기로 설정하려면 클릭하세요.',
			clickToCreateOwnCategory: '자신만의 카테고리를 만들려면 클릭하세요.',
			howLearningLookLike: '학습은 어떻게 진행되나요?',
			restText:
				'학습은 플래시카드를 검토하고 지식을 평가하는 것입니다. 또한, 간단한 작업을 해결하게 됩니다.',
		},
		chat: {
			title: '채팅',
			subtitle: '어떤 주제든 이야기해 보세요.',
		},
		fotoMode: {
			title: '사진 퍼즐',
			subtitle: '사진을 가능한 한 자세하게 설명하세요.',
		},
		scene: {
			title: '장면',
			subtitle: 'AI 튜터와 역할극을 해 보세요.',
		},
		word: {
			title: '단어',
			subtitle: '어휘를 확장하세요.',
		},
		flashcard: {
			title: '플래시카드',
			subtitle: '단어를 복습하고 암기하세요.',
		},
		seeMore: '모두 보기',
	},
	common: {
		description:
			'Synthi AI - 영어 학습을 위한 스마트 어시스턴트. 인공지능의 도움으로 영어를 유창하게 배울 수 있습니다. 새로운 외국어 학습 방법을 발견하세요. 오늘 바로 시작하세요!',
		deletedFromFavorite: '즐겨찾기에서 삭제됨',
		addedToFavorite: '즐겨찾기에 추가됨',
		flashcards: '플래시카드',
		flashcards_v2: '플래시카드',
		scenes: '장면',
		scenes_v3: '장면',
		words: '단어',
		or: '또는',
		continueWithFB: 'Facebook으로 계속',
		privacyLink: 'privacy',
		termsLink: 'tos',
	},
	profile: {
		days: ['월', '화', '수', '목', '금', '토', '일'],
		top: {
			profile: '프로필',
			accessTo: '접근:',
			profileImage: '프로필 이미지',
			nameAndSurname: '이름',
			password: '비밀번호',
			change: '변경',
			changeProfileImage: '프로필 이미지 변경',
			changeNameAndSurname: '이름 변경',
			changeNameAndSurnamePlaceHolder: '이름을 입력하세요',
			save: '저장',
			changePassword: '비밀번호 변경',
			passwordInfo:
				'비밀번호는 최소 8자 이상이어야 하며 대소문자 및 숫자가 포함되어야 합니다.',
			repeatPassword: '비밀번호 반복',
			passwordChanged: '비밀번호가 변경되었습니다.',
			error: '문제가 발생했습니다.',
			nameChanged: '이름이 변경되었습니다.',
			profileChanged: '프로필이 변경되었습니다.',
		},
		plan: {
			subInfo:
				'구독 취소를 원하시면 contact@synthiaiapp.com으로 이메일을 보내주세요.',
			yourPlan: '당신의 계획',
			extend: '계획 연장',
			short_extend: '연장',
			currentPlan: '현재 계획:',
			activeToPlan: '유효 기간:',
			currentPlanLong: '현재 계획',
		},
		middle: {
			yourMedals: '당신의 메달',
			oneDay: '일',
			twoDays: '일',
			words: '단어',
			learningTime: '학습 시간',
			streak: '연속',
			streakRecord: '연속 기록',
			yourRecord: '당신의 기록:',
			currentRecord: '현재 기록:',
			words: '단어',
			wordsInWeek: '주간 단어 수:',
		},
		bottom: {
			yourTutor: '당신의 튜터 AI',
			change: '변경',
			logout: '로그아웃',
			FAQ: '자주 묻는 질문',
			shareOpinion: '의견 공유',
			yourPlan: '당신의 계획',
			hobby: '관심사',
			learningSetting: '학습 설정',
			back: '뒤로',
			dayTarget: '일일 목표',
			languageLevel: '언어 수준',
			changeYourLangLevel: '언어 수준 변경',
			pickNewTutor: '새 튜터 선택',
			yourDecision: '당신의 선택은 수업 스타일에 영향을 미칩니다.',
			tutroChanged: '튜터가 변경되었습니다.',
			error: '문제가 발생했습니다.',
			englishLevelChanged: '영어 수준이 변경되었습니다.',
			levelsOptions: [
				{
					name: '초급 A1',
					description: '영어 여행을 시작하세요',
					value: 'basic',
					borderRadius: '8px 8px 0 0',
				},
				{
					name: '초급 A2',
					description: '기본적인 일상 대화를 이해할 수 있습니다.',
					borderRadius: '0',
					value: 'beginner',
				},
				{
					name: '중급 B1',
					description: '일상적인 주제에 대해 간단한 대화를 할 수 있습니다.',
					borderRadius: '0',
					value: 'intermediate',
				},
				{
					name: '고급 B2',
					description: '대부분의 상황에서 자유롭게 의사소통할 수 있습니다.',
					borderRadius: '0',
					value: 'advanced',
				},
				{
					name: '전문가 C1+',
					description: '복잡한 상황에서 효과적으로 영어를 구사합니다.',
					value: 'expert',
					borderRadius: '0 0 8px 8px ',
				},
			],
			changeDailyTarget: '일일 학습 목표를 변경하세요.',
			deletedFromFavorite: '즐겨찾기에서 삭제됨',
			addedToFavorite: '즐겨찾기에 추가됨',
			lessonTime: [
				{
					name: '빠른 수업',
					dsecription: '빠른 학습을 위한 최적의 선택',
					time: '5분',
					value: 'five_minutes',
					borderRadius: '8px 8px 0 0',
				},
				{
					name: '표준 세션',
					dsecription: '균형 잡힌 학습을 위한 훌륭한 선택',
					time: '10분',
					value: 'ten_minutes',
					borderRadius: '0',
				},
				{
					name: '집중 훈련',
					dsecription: '학습 열정을 위한 최고의 선택',
					time: '15분',
					value: 'fifteen_minutes',
					borderRadius: '0 0 8px 8px ',
				},
			],
			dailyTargetChanged: '일일 목표 변경!',
			pickIntresets: '최소 3개의 관심사를 선택하세요.',
			activeTo: '계획은 다음까지 유효합니다:',
			daysLeft: '계획 남은 일수:',
			opinionSubtitle:
				'우리는 지속적으로 앱을 개선하고 있습니다. 앱에서 변경해야 할 점이나 가장 좋았던 점을 알려주세요.',
			startTyping: '의견을 입력하세요.',
			faq: '자주 묻는 질문',
			send: '보내기',
			withProblems: '문제가 있으면 contact@synthiaiapp.com으로 연락주세요.',
			contactMail: 'contact@synthiaiapp.com',
			faqConfig: [
				{
					id: 1,
					question: '내 소리가 들리지 않아요.',
					answer: `소리가 들리지 않으면 다음 사항을 확인하세요: 
      
              브라우저의 소리 권한을 확인하세요.
      
              장치의 볼륨을 확인하세요.
      
              스피커/헤드셋 연결 상태를 확인하세요.
      
              시스템의 사운드 설정을 확인하여 앱이 음소거되지 않았는지 확인하세요.
      
              다른 장치를 사용하거나 기술 지원에 문의하세요.`,
				},
				{
					id: 2,
					question: '내 목소리를 녹음할 수 없어요.',
					answer: `오디오 녹음에 문제가 있으면 다음 사항을 확인하세요: 
              
              브라우저의 마이크 권한을 확인하세요.
      
              모바일 브라우저가 마이크에 접근할 수 있는지 확인하세요.
      
              마이크가 제대로 연결되어 있는지 확인하세요.
      
              다른 장치를 사용하거나 기술 지원에 문의하세요.`,
				},
				{
					id: 3,
					question: '여러 장치에서 앱을 사용할 수 있나요?',
					answer: `물론입니다. 각 호환 장치에서 로그인하여 계속 학습하세요.`,
				},
				{
					id: 4,
					question: 'Synthi Ai는 오프라인에서 사용할 수 있나요?',
					answer: `아니요, Synthi Ai는 인터넷에 접속할 수 있는 웹 브라우저가 필요합니다.`,
				},
				{
					id: 5,
					question: '내 AI 튜터를 어떻게 변경하나요?',
					answer: `Synthi Ai 설정에서 "튜터"로 이동하여 원하는 튜터를 선택하세요.`,
				},
				{
					id: 6,
					question: '만료된 후에는 어떻게 액세스를 연장하나요?',
					answer: `만료 후 로그인하여 플랜을 연장할 수 있습니다.`,
				},
				{
					id: 7,
					question: '영수증을 받을 수 있나요?',
					answer:
						'contact@synthiaiapp.com으로 연락하여 세금 코드와 회사 정보를 제공해주세요.',
				},
				{
					id: 8,
					question: '기술 지원에 어떻게 연락하나요?',
					answer:
						'contact@synthiaiapp.com으로 이메일을 보내고 문제에 대한 세부 사항과 장치 및 브라우저 정보를 제공하세요.',
				},
			],
		},
		rules: '규칙',
		privacy: '개인정보 보호정책',
		span: ' 및 ',
	},
	welcome: {
		languagePicker: {
			title: '배울 언어를 선택하세요',
			next: '다음',
			langToLearn: '배울 언어',
			successTitle: '배울 언어가 변경되었습니다',
			config: [
				{
					label: '영어',
					label2: '영어',
					labelInside: '영어',
					value: 'en',
				},
				{
					label: '독일어',
					label2: '독일어',
					labelInside: '독일어',
					value: 'de',
				},
				{
					label: '스페인어',
					label2: '스페인어',
					labelInside: '스페인어',
					value: 'es',
				},
				{
					label: '프랑스어',
					label2: '프랑스어',
					labelInside: '프랑스어',
					value: 'fr',
				},
				{
					label: '이탈리아어',
					label2: '이탈리아어',
					labelInside: '이탈리아어',
					value: 'it',
				},
			],
		},
		zeroScreen: {
			welcomeInApp: 'Synthi AI 앱에 오신 것을 환영합니다!',
			start: '시작하기',
			welcomeMobile: '환영합니다',
			config: {
				chrome: {
					title: 'Android 장치에 앱을 설치하세요.',
					text1: '버튼을 눌러',
					text1bold: '설정',
					image1: Android1,
					text2: '그런 다음',
					text2bold: '홈 화면에 추가',
					image2: Android2,
					text3: '완료! 이제 Synthi AI가 홈 화면에 추가되었습니다.',
					image3: Last,
				},
				safari: {
					title: 'iOS 장치에 앱을 설치하세요.',
					text1: '버튼을 눌러',
					text1bold: '공유',
					image1: Ios1,
					text2: '그런 다음',
					text2bold: '홈 화면에 추가',
					image2: Ios2,
					text3: '완료! 이제 Synthi AI가 홈 화면에 추가되었습니다.',
					image3: Last,
				},
			},
		},
		firstScreen: {
			title: '튜터를 선택하세요!',
			subtitle: '귀하의 결정은 수업의 스타일과 분위기에 영향을 미칩니다.',
			next: '계속',
		},
		secondScreen: {
			title: '{language}의 현재 수준은 무엇인가요?',
			config: [
				{
					name: '초급 A1',
					description: '{language} 학습을 시작하세요.',
					value: 'basic',
				},
				{
					name: '초급 A2',
					description: '기본적인 일상 대화를 이해할 수 있습니다.',
					value: 'beginner',
				},
				{
					name: '중급 B1',
					description: '일상적인 주제에 대해 간단한 대화를 할 수 있습니다.',
					value: 'intermediate',
				},
				{
					name: '고급 B2',
					description: '대부분의 상황에서 자유롭게 의사소통할 수 있습니다.',
					value: 'advanced',
				},
				{
					name: '전문가 C1+',
					description: '복잡한 상황에서 효과적으로 영어를 구사합니다.',
					value: 'expert',
				},
			],
			next: '계속',
		},
		thirdScreen: {
			title: '당신의 관심사는 무엇인가요?',
			subtitle: '최소 3개 이상의 관심사를 선택하세요.',
			next: '계속',
		},
		fourthScreen: {
			title: '하루에 몇 분을 학습하고 싶으신가요?',
			subtitle: '일일 학습 목표를 선택하세요.',
			next: '시작하기!',
			config: [
				{
					name: '빠른 수업',
					dsecription: '빠른 학습을 위한 최적의 선택',
					time: '5분',
					value: 'five_minutes',
				},
				{
					name: '표준 세션',
					dsecription: '균형 잡힌 학습을 위한 훌륭한 선택',
					time: '10분',
					value: 'ten_minutes',
				},
				{
					name: '집중 훈련',
					dsecription: '학습 열정을 위한 최고의 선택',
					time: '15분',
					value: 'fifteen_minutes',
				},
			],
		},
	},
	features: {
		wordTrainer: {
			next: '다음',
			yourSpeaking: '발음',
			you: '당신',
			title: '단어 트레이너',
			errorMessage:
				'문제 발생! 녹음 처리가 잘못되었습니다. 다시 시도해보세요 :)))',
			endScreenTitle: '환상적! 🌟🌟🌟',
			endScreenTopInfo: '모든 단어를 마스터했어요!',
			endScreenMiddleInfo: '이 수준의 단어들',
			endScreenBottomInfo: '끝냈습니다.',
			endScreenText: '다시 시작하거나 설정에서 수준을 변경하세요.',
			endScreenBottomText: '다시 시작',
			endScreenEndText: '완료',
			sesionScoreTitle: '훌륭해요! 🎉',
			sesionScoreSubTitle: '발음을 개선하고 있어요',
			sesionScoreWord: '단어',
			now: '지금',
			sum: '총',
			continue: '계속',
			areYouSureToEndLesson: '수업을 종료할까요?',
			speakingScore: '발음 점수',
			GOOD_ARRAY: [
				'잘했어요!',
				'완벽해요!',
				'당신은 챔피언이에요!',
				'훌륭해요!',
				'놀라워요!',
				'천재네요!',
			],
			BAD_ARRAY: [
				'포기하지 마세요!',
				'할 수 있어요!',
				'더 가까워졌어요!',
				'계속 반복하면 성공할 거예요!',
				'곧 성공할 거예요!',
				'걱정하지 마세요, 다시 시도해보세요!',
			],
			OK_ARRAY: [
				'잘 하고 있어요!',
				'아주 가까워요!',
				'점점 좋아지고 있어요!',
				'점차 발전하고 있어요!',
				'노력한 만큼 성장하고 있어요!',
			],
			hold: '누르고',
			holdText: '마이크를 누르고 말하세요:',
			tutorial: {
				title: '단어 트레이너 사용법',
				options: [
					{
						label: '발음 듣기 위해 클릭하세요',
						icon: Micro,
					},
					{
						label: '누르고 발음해보세요',
						icon: Voice,
					},
					{
						label: '누르고 내 녹음을 들으면 단어를 완벽하게 배울 수 있어요!',
						icon: Person,
					},
				],
				close: '닫기',
			},
		},
		sceneV3: {
			twoToFiveMinutes: '2-5 분',
			twoToFiveMin: '2-5 분',
			role: '역할',
			description: '설명',
			task: '작업',
			tasks: '작업들',
			conversationStarted: '대화 시작됨',
			areYouSureYouWantToLeave: '정말 나가시겠어요?',
			youWillLoseProgress: '진행 상황이 사라집니다.',
			continue: '계속',
			leave: '떠나다',
			congratulations: '축하합니다!',
			yourAnswersWereClearAndLucid: '당신의 답변은 명확하고 일관성 있었습니다.',
			finish: '끝내기',
			howToUseScenes: '장면 사용법',
			buyingShoes: '신발 구매',
			clickSelectedScene: '선택한 장면을 클릭하여 학습을 시작하세요.',
			clickToMarkAsFavorite: '즐겨찾기로 표시하려면 클릭하세요.',
			youSeeWhenSceneIsDone: '장면이 끝나면 알림이 뜹니다.',
			howLearningLookLike: '학습 방법',
			learningIsAbout:
				'학습은 짧은 대화를 하고 장면 설명과 작업을 수행하는 것입니다.',
			close: '닫기',
			clickToShareOpinion: '의견을 공유하려면 클릭하세요',
			clickToShownInstructions: '지침을 열려면 클릭하세요',
			clickToCheckTasks: '작업을 확인하려면 클릭하세요',
			clickToHearAgain: '다시 들으려면 클릭하세요',
			clickToShowTranslation: '번역을 보려면 클릭하세요',
			clickToShowHint: '힌트를 보려면 클릭하세요',
			clickToReportAProblem: '문제를 보고하려면 클릭하세요',
			yourAnswerIsCorrect: '정답입니다',
			clickToShowCorrectAnswer: '정답과 설명을 보려면 클릭하세요',
			clickInTheTextInput: '텍스트 입력란을 클릭하여 답변을 작성하세요',
			clickToStartRecording: '녹음을 시작하려면 클릭하세요',
			taskCompleted: '작업 완료',
			whenAllTasksAreDone: '모든 작업이 완료되면 장면이 끝납니다.',
			start: '시작',
			next: '다음',
			skip: '건너뛰기',
			howToTalkInScenes: '장면에서 어떻게 대화하나요?',
		},
		topbar: {
			back: '뒤로',
		},
		fotoMode: {
			welcome: {
				title: '사진 퍼즐',
				subtitle: '선택한 주제에 대해 최대한 자세히 사진을 설명하세요.',
				start: '시작!',
			},
			info: {
				startTyping: '입력 시작...',
				newTask: '새로운 작업',
				send: '보내기',
			},
		},
		flashcards: {
			title: '플래시카드',
			subtitleTop: '플래시카드를 사용하여 새로운 단어를 학습하고 기억하세요.',
			addCategory: '내 카테고리 추가',
			subtitle: '카테고리 이름 입력',
			type: '카테고리 입력...',
			add: '추가',
			previous: '이전 플래시카드',
			task: '작업',
			changeLevel: '레벨 변경',
			dontKnow: '모르겠어요',
			know: '알아요',
			pickPairs: '쌍 맞추기',
			goodJob: '잘했어요!',
			titleEnd: '당신의 노력은 인상적이에요',
			subtitleEnd: '다른 도전을 준비됐나요?',
			repeat: '카테고리 반복하기',
			other: '다른 카테고리 선택하기',
			level: {
				title: '플래시카드 레벨 변경',
				beginner: '초급 A1-A2',
				intermediate: '중급 B1-B2',
				advance: '고급 C1-C2',
				change: '변경',
			},
		},
		scene: {
			title: '장면',
			subtitle: 'AI 튜터와 함께 주제를 선택하여 역할극을 해보세요.',
			suggest: '새 장면 제안',
			talk: '대화하기',
			deletedFromFavorite: '즐겨찾기에서 삭제됨',
			addedToFavorite: '즐겨찾기에 추가됨',
		},
		word: {
			title: '단어',
			subtitle: 'AI 튜터와 함께 중요한 대화 주제를 학습하여 어휘를 확장하세요.',
			suggest: '새 단어 주제 제안',
			deletedFromFavorite: '즐겨찾기에서 삭제됨',
			addedToFavorite: '즐겨찾기에 추가됨',
		},
	},
	cookie: {
		title: '이 사이트는 쿠키를 사용합니다',
		subtitle:
			'콘텐츠를 개인화하고, 트래픽을 분석하며, 맞춤형 광고를 표시하기 위해 쿠키를 사용합니다. 개인 정보 설정을 관리할 수 있습니다. 자세한 내용은',
		link: '개인정보 보호정책',
		accept: '수락',
		denied: '거부',
		manage: '개인화',
		saveChanges: '변경 사항 저장',
		necessary: {
			top: '필수',
			text: '이 쿠키는 사이트가 올바르게 작동하는 데 필요합니다.',
		},
		functional: {
			top: '기능적',
			text: '언어와 같은 설정을 기억합니다.',
		},
		analytical: {
			top: '분석적',
			text: '사이트 개선을 위해 트래픽을 측정하는 데 도움이 됩니다.',
		},
		marketing: {
			top: '마케팅',
			text: '광고와 리마케팅을 개인화할 수 있습니다.',
		},
		personalization: {
			top: '개인화 콘텐츠',
			text: '사용자의 관심사에 맞춰 사이트 콘텐츠와 제품 추천을 개인화할 수 있습니다.',
		},
	},
	talkingBar: {
		allowMicrofon: '마이크 접근을 허용해 주세요',
		typeMessage: '메시지 입력...',
		record: '녹음',
		recording: '녹음 중',
	},
	hands: {
		giveUsInfo: '의견을 나누세요.',
		thanksForGrading: '평가해 주셔서 감사합니다!',
		subtitle: '당신의 의견은 저희에게 중요합니다!',
		subtitle2: '이 수업에 대해 어떤 의견을 갖고 있나요?',
		skip: '건너뛰기',
		send: '보내기',
	},
	suggestConfig: {
		profile: {
			title: '당신의 의견을 공유하세요!',
			subtitle:
				'우리는 계속해서 앱을 개선하고 있습니다. 무엇을 변경하거나 무엇이 좋았는지 알려주세요.',
		},
		word: {
			title: '새 단어 주제 제안',
			subtitle: '',
		},
		scene: {
			title: '새 장면 제안',
			subtitle: '',
		},
		startTyping: '입력 시작',
		send: '보내기',
		thx: '의견이 추가되었습니다! 감사합니다!',
		error: '문제가 발생했습니다',
	},
	checkout: {
		emailGuessText: '이메일을 잘못 입력하셨나요?',
		leftTitle: '자신의 계획을 선택하세요',
		rightTitle: '정보 입력',
		email: '이메일',
		placeHolderEmail: '이메일을 입력하세요',
		pay: '구매하고 결제',
		accept: '동의',
		rules: '규정',
		space: '및',
		tos: '개인정보 보호정책',
		payingAccept: '결제 시 동의',
		paymentRules: '"PayU 결제 규정"',
		savePayments: '안전한 결제는',
		total: '총',
		currency: '원',
		currencySign: '원',
		subscribe: '지금 결제',
	},
	dailyV2: {
		conversation: {
			doYouWantContinueConversation:
				'대화를 계속하시겠어요, 아니면 새 대화를 시작하시겠어요?',
			continueConversation: '대화 계속',
			newConversation: '새 대화',
		},
		hint: {
			title: '힌트',
			pick: '선택',
			writeOrRecordAResponse: '응답을 작성하거나 녹음하십시오',
			tryToSay: '말해 보세요',
		},
		feedback: {
			yourMessage: '당신의 메시지',
			goodMessage: '올바른 메시지',
			explanation: '설명',
		},
		tutorial: {
			title: '채팅 사용법',
			skip: '건너뛰기',
			next: '다음',
			start: '시작',
			screenConf: [ScreenOne, ScreenTwo, ScreenThree, ScreenFour],
			config: [
				[
					{
						title: '튜터의 소리를 끄려면 클릭하세요',
						image: VolumeUp,
					},
					{ title: '피드백을 제공하려면 클릭하세요', image: HandsUp },
					{
						title: '지침을 보려면 클릭하세요',
						image: Tutorial,
					},
				],
				[
					{ title: '다시 듣기 위해 클릭하세요', image: VolumeUpBlank },
					{
						title: '번역을 보려면 클릭하세요',
						image: TranslationBlank,
					},
					{ title: '힌트를 보려면 클릭하세요', image: HintBlank },
					{ title: '문제를 신고하려면 클릭하세요', image: InfoBlank },
				],
				[
					{ title: '정답입니다', image: GreenCircle },
					{
						title: '수정된 정답과 설명을 보려면 클릭하세요',
						image: YellowCircle,
					},
				],
				[{ title: '메시지 입력란을 클릭하여 답변 작성', image: Microphone }],
			],
		},
	},
	problem: {
		title: '문제 신고',
		subtitle: 'AI 메시지 관련 문제를 설명해주세요',
		send: '보내기',
		messageSend: '메시지 전송 완료',
		error: '뭔가 잘못되었습니다. 저희에게 알려주세요 :)',
	},
	footer: {
		copy: 'Copyright©',
		privacy: '개인정보 보호정책',
		cookie: '쿠키 정책',
		rules: '이용 약관',
		privacyUrl: '/privacy',
		rulesUrl: '/tos',
	},
};
